(() => {
  const selectors = {
    scale: '[data-ticker-scale]',
    text: '[data-ticker-text]',
  };

  const attributes = {
    clone: 'data-clone',
    autoplay: 'autoplay',
    speed: 'speed',
    static: 'static',
  };

  const classes = {
    animated: 'ticker--animated',
    unloaded: 'ticker--unloaded',
    comparitor: 'ticker__comparitor',
  };

  const defaultSpeed = 1.63;
  const pxPerSecond = 100;

  if (customElements.get('ticker-bar')) return;

  customElements.define(
    'ticker-bar',
    class TickerBar extends HTMLElement {
      constructor() {
        super();

        this.isStatic = this.hasAttribute(attributes.static);
        this.autoplay = this.hasAttribute(attributes.autoplay);
        this.scale = this.querySelector(selectors.scale);
        this.text = this.querySelector(selectors.text);
        this.speed = this.hasAttribute(attributes.speed) ? this.getAttribute(attributes.speed) : defaultSpeed;
        this.scale?.classList.remove(classes.unloaded);

        if (this.isStatic) return;

        this.comparitor = this.text.cloneNode(true);
        this.comparitor.classList.add(classes.comparitor);
        this.appendChild(this.comparitor);
        this.checkWidthEvent = () => this.checkWidth();
        this.refreshEvent = window.theme.debounce(this.checkWidthEvent, 50);
      }

      connectedCallback() {
        if (this.isStatic) return;

        this.checkWidth();
        this.addEventListener('theme:ticker:refresh', this.refreshEvent);
        screen.orientation?.addEventListener('change', this.checkWidthEvent);
        document.addEventListener('theme:resize:width', this.checkWidthEvent);
      }

      disconnectedCallback() {
        if (this.isStatic) return;

        screen.orientation?.removeEventListener('change', this.checkWidthEvent);
        document.removeEventListener('theme:resize:width', this.checkWidthEvent);
      }

      removeClones() {
        this.scale.querySelectorAll(`[${attributes.clone}]`).forEach((clone) => clone.remove());
      }

      checkWidth() {
        this.text = this.querySelector(selectors.text);

        const padding = 2 * parseFloat(window.getComputedStyle(this).paddingLeft);
        const isOverflowing = this.clientWidth - padding < this.comparitor.clientWidth;

        if (!isOverflowing && !this.autoplay) {
          this.removeClones();
          this.text.classList.remove(classes.animated);
          return;
        }

        this.text.classList.remove(classes.animated);
        this.removeClones();

        const cloneCount = this.autoplay ? parseInt((window.innerWidth - padding) / this.text.clientWidth) : 2;
        for (let i = 0; i <= cloneCount; i++) {
          const clone = this.text.cloneNode(true);
          clone.setAttribute(attributes.clone, '');
          this.scale.appendChild(clone);
        }

        const animationTime = ((this.text.clientWidth / pxPerSecond) * Number(this.speed)).toFixed(2);
        this.scale.style.setProperty('--animation-time', `${animationTime}s`);
        this.scale.querySelectorAll(selectors.text).forEach((text) => text.classList.add(classes.animated));
      }
    }
  );
})();
